<template>
  <div>
    <main role="main">
      <div class="page-content">
        <div class="container py-md-5 py-4">
          <div class="row justify-content-center">
            <div class="col-lg-12">
              <div class="row align-items-center mb-4">
                <div class="col-md-6">
                  <h2 class="page-title mb-md-0 mb-3">
                    <a
                      class="cursor-pointer"
                      v-on:click="$router.push('/dashboard')"
                      ><img
                        src="/images/back-arrow.svg"
                        width="20"
                        alt=""
                        class="me-2"
                    /></a>
                    My Activity
                  </h2>
                </div>
                <div class="col-md-6 text-end"></div>
              </div>

              <ul
                class="nav nav-pills mb-3 tab-style-1"
                id="login-tab"
                role="tablist"
                style="height: 100px">
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class="nav-link"
                    role="tab"
                    style="height: 100px"
                    v-on:click="$router.push('/recently-viewed')"
                    >Recently Viewed <br />profiles ({{
                      count.recently_view_count >= 0
                        ? count.recently_view_count
                        : " "
                    }})</a
                  >
                </li>
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class="nav-link"
                    role="tab"
                    style="height: 100px"
                    v-on:click="$router.push('/shortlisted')"
                    >Shortlisted <br />({{
                      count.shortlisted_count >= 0
                        ? count.shortlisted_count
                        : " "
                    }})</a
                  >
                </li>
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class="nav-link"
                    style="height: 100px"
                    v-on:click="$router.push('/intrest-sent')"
                    >Interest Sent <br />({{
                      count.intrest_sent_count >= 0
                        ? count.intrest_sent_count
                        : " "
                    }})</a
                  >
                </li>
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class="nav-link activ"
                    style="height: 100px"
                    v-on:click="$router.push('/intrest-recieved')"
                    >Interest Received <br />({{
                      count.intrest_recieved_count >= 0
                        ? count.intrest_recieved_count
                        : " "
                    }})</a
                  >
                </li>
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class="nav-link"
                    style="height: 100px"
                    v-on:click="$router.push('/contacts-viewed')"
                    >Viewed Contacts <br />({{
                      count.viewed_contact_count >= 0
                        ? count.viewed_contact_count
                        : " "
                    }})</a
                  >
                </li>
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class="nav-link"
                    style="height: 100px"
                    v-on:click="$router.push('/blocked-users')"
                    >Blocked Users<br />({{
                      count.block_count >= 0 ? count.block_count : " "
                    }})</a
                  >
                </li>
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class="nav-link"
                    style="height: 100px"
                    v-on:click="$router.push('/reported-users')"
                    >Reported Users<br />({{
                      count.report_count >= 0 ? count.report_count : " "
                    }})</a
                  >
                </li>
              </ul>

              <div class="tab-content form-style">
                <!-- Interest Received  -->
                <h6 style="font-weight: bold !important">
                  Note : Do not keep interest on pending for longer days as user
                  can cancel anytime
                </h6>
                <div
                  class="tab-pane fade show active"
                  id="tab_4"
                  role="tabpanel"
                  aria-labelledby="">
                  <ul
                    class="nav nav-pills mb-3 tab-style-1"
                    id="subTab_2"
                    role="tablist">
                    <li class="nav-item cursor-pointer" role="presentation">
                      <a
                        class="nav-link"
                        :class="currentTab == 'PENDING' ? 'activ' : ''"
                        id="email-tab"
                        v-on:click="changeTab('PENDING')"
                        >Pending Interests ({{
                          count.pending_recieved_intrest_count >= 0
                            ? count.pending_recieved_intrest_count
                            : " "
                        }})</a
                      >
                    </li>
                    <li class="nav-item cursor-pointer" role="presentation">
                      <a
                        class="nav-link"
                        id="phone-tab"
                        :class="currentTab == 'ACCEPTED' ? 'activ' : ''"
                        v-on:click="changeTab('ACCEPTED')"
                        >Accepted Interest ({{
                          count.accepted_recieved_intrest_count >= 0
                            ? count.accepted_recieved_intrest_count
                            : " "
                        }})</a
                      >
                    </li>
                    <li class="nav-item cursor-pointer" role="presentation">
                      <a
                        class="nav-link"
                        id="phone-tab"
                        :class="currentTab == 'REJECTED' ? 'activ' : ''"
                        v-on:click="changeTab('REJECTED')"
                        >Rejected Interest ({{
                          count.rejected_recieved_intrest_count >= 0
                            ? count.rejected_recieved_intrest_count
                            : " "
                        }})</a
                      >
                    </li>
                  </ul>

                  <div class="tab-content form-style">
                    <div
                      v-if="currentTab == 'PENDING'"
                      class="tab-pane fade show active"
                      id="tab_1_3"
                      :class="currentTab == 'PENDING' ? 'show active' : ''">
                      <div
                        class="border-top pt-4"
                        v-for="(data, index) in Users"
                        :key="index">
                        <div class="row">
                          <div class="col-lg-3 col-md-4 mb-4 position-relative">
                            <div
                              :id="'ProfileSlider1_' + index"
                              class="carousel slide profile-sider"
                              data-bs-ride="carousel"
                              data-bs-interval="false">
                              <div
                                class="carousel-inner rounded-l cursor-pointer"
                                v-if="
                                  data.to_user.user_images.length > 0 ||
                                  data.to_user.user_images != null
                                ">
                                <div
                                  class="carousel-item"
                                  v-for="(data1, index1) in data.to_user
                                    .user_images"
                                  :key="index1"
                                  :class="index1 == 0 ? 'active' : ' '">
                                  <img
                                    :src="
                                      data1.image
                                        ? data1.image
                                        : 'img/profile-holder.png'
                                    "
                                    class="photos"
                                    alt="..." />
                                </div>
                              </div>
                              <div
                                class="carousel-inner rounded-l new cursor-pointer"
                                v-if="
                                  data.to_user.user_images.length == 0 ||
                                  data.to_user.user_images == null
                                ">
                                <div class="carousel-item active">
                                  <img
                                    src="img/profile-holder.png"
                                    class="photos"
                                    alt="..." />
                                </div>
                              </div>
                              <div v-show="data.to_user.user_images.length">
                                <button
                                  class="carousel-control-prev"
                                  type="button"
                                  :data-bs-target="'#ProfileSlider1_' + index"
                                  data-bs-slide="prev">
                                  <span
                                    class="carousel-control-prev-icon"
                                    aria-hidden="true"></span>
                                  <span class="visually-hidden">Previous</span>
                                </button>
                              </div>
                              <div v-show="data.to_user.user_images.length">
                                <button
                                  class="carousel-control-next"
                                  type="button"
                                  :data-bs-target="'#ProfileSlider1_' + index"
                                  data-bs-slide="next">
                                  <span
                                    class="carousel-control-next-icon"
                                    aria-hidden="true"></span>
                                  <span class="visually-hidden">Next</span>
                                </button>
                              </div>
                            </div>
                            <div
                              class="text-center my-3 carousel-counter"
                              id="slide-counter">
                              <div class="num text-white"></div>
                            </div>
                          </div>
                          <div class="col-lg-7 col-md-8 cursor-pointer">
                            <div class="row">
                              <div
                                class="col-lg-6"
                                v-on:click="
                                  $router.push(
                                    '/activity-profile-view/' +
                                      data.to_user.uuid +
                                      '/PENDING/' +
                                      data.uuid,
                                  )
                                ">
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Registration No.</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.registration_no
                                          ? data.to_user.registration_no
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Surname</label>
                                  </div>
                                  <div
                                    class="col-6"
                                    style="word-break: break-all !important">
                                    <p class="font-medium pink-clr">
                                      <!-- {{
                                        data.to_user.first_name
                                          ? data.to_user.first_name
                                          : ""
                                      }}
                                      {{
                                        data.to_user.middle_name
                                          ? data.to_user.middle_name
                                          : ""
                                      }} -->
                                      {{
                                        data.to_user.last_name
                                          ? data.to_user.last_name
                                          : ""
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <!-- <div
                                  class="row"
                                  v-if="
                                    mydetail.is_membership_subscribed == 'N'
                                  ">
                                  <div class="col-6">
                                    <label for="">Surname</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium pink-clr">
                                      {{
                                        data.to_user.last_name
                                          ? data.to_user.last_name
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div> -->
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Date of Birth</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.dob
                                          ? $helperService.getFormatedDate(
                                              data.to_user.dob,
                                            )
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Height</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.height
                                          ? $helperService.getHeight(
                                              data.to_user.height,
                                            )
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Education</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.education_courses
                                          ? data.to_user.education_courses
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="col-lg-6"
                                v-on:click="
                                  $router.push(
                                    '/activity-profile-view/' +
                                      data.to_user.uuid +
                                      '/PENDING/' +
                                      data.uuid,
                                  )
                                ">
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Occupation</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.occupation_details
                                          ? data.to_user.occupation_details
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Annual Income (Lakh)</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.annual_income ||
                                        data.to_user.annual_income == 0
                                          ? data.to_user.annual_income
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Working city</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.working_place_taluka
                                          ? data.to_user.working_place_taluka
                                              .name
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Native Place</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.native_place_district
                                          ? data.to_user.native_place_district
                                              .name
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <!-- <div class="row">
                                  <div class="col-6">
                                    <label for="">Gun Milan</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.gan
                                          ? data.to_user.gan.name
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div> -->
                              </div>
                              <div class="col-md-12 text-center mt-3">
                                <p>
                                  Received on
                                  {{
                                    data.created_at
                                      ? $helperService.getFormatedDate(
                                          data.created_at,
                                        )
                                      : "-"
                                  }}
                                </p>
                                <!-- &&
                                    mydetail.is_membership_subscribed == 'Y' -->
                                <button
                                  v-if="data.status == 'PENDING'"
                                  type="button"
                                  class="btn btn-outline-brand-1 me-3"
                                  v-on:click="accept(data, index)">
                                  <i class="fa fa-check" aria-hidden="true"></i>
                                  Accept
                                </button>
                                <button
                                  v-if="data.status == 'PENDING'"
                                  type="button"
                                  class="btn btn-outline-brand-1"
                                  v-on:click="showRejectpopup(data, index)">
                                  <i class="fa fa-times" aria-hidden="true"></i>
                                  Reject
                                </button>
                              </div>
                              <!-- <div class="col-md-6 text-center mt-3">
                          <p>Sent on on 11/10/2020 dd</p>
                          <button type="button" class="btn btn-outline-brand-1"><i class="fa fa-check" aria-hidden="true"></i> Accept </button>
                        </div>
                      <div class="col-md-6 text-center mt-3">
                          <p>Viewed on on 11/10/2020 dd</p>
                          <button type="button" class="btn btn-outline-brand-1"><i class="fa fa-times" aria-hidden="true"></i> Reject</button>
                        </div> -->
                            </div>
                          </div>
                          <div class="col-lg-2 col-md-4 ps-md-0">
                            <!-- <button
                              v-on:click="
                                showRemmaingtactModel(data.from_user_id)
                              "
                              class="btn btn-outline-brand-1 mb-2 w-100"
                            >
                              <i
                                class="fa fa-eye font-20 me-2"
                                aria-hidden="true"
                              ></i>
                              View Contact
                            </button> -->
                            <button
                              v-if="!data.hasViewContact"
                              v-on:click="
                                showRemmaingtactModel(data.from_user_id)
                              "
                              class="btn btn-outline-brand-1 mt-2 mb-3 w-100">
                              <i
                                class="fa fa-eye font-20 me-2"
                                aria-hidden="true"></i>
                              View Contact
                            </button>
                            <button
                              v-if="data.hasViewContact"
                              v-on:click="
                                showRemmaingtactModel(data.from_user_id)
                              "
                              class="btn btn-brand-1 mt-2 mb-3 w-100">
                              <i
                                class="fa fa-eye font-20 me-2"
                                aria-hidden="true"></i>
                              View Contact
                            </button>
                            <!-- <button
                              type="button"
                              class="btn btn-brand-1 w-100 mb-2"
                              v-if="!data.hasSentIntrest"
                              v-on:click="sendIntrest(data)"
                            >
                              <i
                                class="fa fa-paper-plane font-20 me-2"
                                aria-hidden="true"
                              ></i>
                              Send interest
                            </button> -->
                            <!-- <button
                              type="button"
                              class="btn btn-brand-1 w-100 mb-2"
                              v-if="data.hasSentIntrest"
                              v-on:click="notIntrested(data)"
                            >
                              <i
                                class="fa fa-paper-plane font-20 me-2"
                                aria-hidden="true"
                              ></i>
                              Cancel Interest
                            </button> -->
                          </div>
                        </div>
                      </div>
                      <ErrorComponent
                        @retry="getRecievedIntrest(0, 'PENDING')"
                        ref="errorComponent"
                        v-if="currentTab == 'PENDING'" />
                      <div class="row mx-0 mb-4" v-if="currentTab == 'PENDING'">
                        <div
                          class="col-lg-12 mt-5 text-right"
                          style="text-align-last: end">
                          <div class="page-bottom-pagination text-right">
                            <Pagination
                              @page-change="pageChange"
                              @items-per-page-change="itemsPerPageChange"
                              ref="listPagination" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Accept interest  -->
                    <div
                      v-if="currentTab == 'ACCEPTED'"
                      class="tab-pane fade"
                      id="tab_2_3"
                      :class="currentTab == 'ACCEPTED' ? 'show active' : ''">
                      <div
                        class="border-top pt-4"
                        v-for="(data, index) in Users"
                        :key="index">
                        <div class="row">
                          <div class="col-lg-3 col-md-4 mb-4 position-relative">
                            <div
                              :id="'ProfileSlider1_' + index"
                              class="carousel slide profile-sider"
                              data-bs-ride="carousel"
                              data-bs-interval="false">
                              <div
                                class="carousel-inner rounded-l cursor-pointer"
                                v-if="
                                  data.to_user.user_images.length > 0 ||
                                  data.to_user.user_images != null
                                ">
                                <div
                                  class="carousel-item"
                                  v-for="(data1, index1) in data.to_user
                                    .user_images"
                                  :key="index1"
                                  :class="index1 == 0 ? 'active' : ' '">
                                  <img
                                    :src="
                                      data1.image
                                        ? data1.image
                                        : 'img/profile-holder.png'
                                    "
                                    class="photos"
                                    alt="..." />
                                </div>
                              </div>
                              <div
                                class="carousel-inner rounded-l new cursor-pointer"
                                v-if="
                                  data.to_user.user_images.length == 0 ||
                                  data.to_user.user_images == null
                                ">
                                <div class="carousel-item active">
                                  <img
                                    src="img/profile-holder.png"
                                    class="photos"
                                    alt="..." />
                                </div>
                              </div>
                              <div v-show="data.to_user.user_images.length">
                                <button
                                  class="carousel-control-prev"
                                  type="button"
                                  :data-bs-target="'#ProfileSlider1_' + index"
                                  data-bs-slide="prev">
                                  <span
                                    class="carousel-control-prev-icon"
                                    aria-hidden="true"></span>
                                  <span class="visually-hidden">Previous</span>
                                </button>
                              </div>
                              <div v-show="data.to_user.user_images.length">
                                <button
                                  class="carousel-control-next"
                                  type="button"
                                  :data-bs-target="'#ProfileSlider1_' + index"
                                  data-bs-slide="next">
                                  <span
                                    class="carousel-control-next-icon"
                                    aria-hidden="true"></span>
                                  <span class="visually-hidden">Next</span>
                                </button>
                              </div>
                            </div>
                            <div
                              class="text-center my-3 carousel-counter"
                              id="slide-counter">
                              <div class="num text-white"></div>
                            </div>
                          </div>
                          <div
                            class="col-lg-7 col-md-8 cursor-pointer"
                            v-on:click="
                              $router.push(
                                '/activity-profile-view/' +
                                  data.to_user.uuid +
                                  '/ACCEPTED/' +
                                  data.uuid,
                              )
                            ">
                            <div class="row">
                              <div class="col-lg-6">
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Reg. No.</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.registration_no
                                          ? data.to_user.registration_no
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Surname</label>
                                  </div>
                                  <div
                                    class="col-6"
                                    style="word-break: break-all !important">
                                    <p class="font-medium pink-clr">
                                      <!-- {{
                                        data.to_user.first_name
                                          ? data.to_user.first_name
                                          : ""
                                      }}
                                      {{
                                        data.to_user.middle_name
                                          ? data.to_user.middle_name
                                          : ""
                                      }} -->
                                      {{
                                        data.to_user.last_name
                                          ? data.to_user.last_name
                                          : ""
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <!-- <div
                                  class="row"
                                  v-if="
                                    mydetail.is_membership_subscribed == 'N'
                                  ">
                                  <div class="col-6">
                                    <label for="">Surname</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium pink-clr">
                                      {{
                                        data.to_user.last_name
                                          ? data.to_user.last_name
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div> -->
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Native Place</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.native_place_district
                                          ? data.to_user.native_place_district
                                              .name
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">DOB</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.dob
                                          ? $helperService.getFormatedDate(
                                              data.to_user.dob,
                                            )
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Height</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.height
                                          ? $helperService.getHeight(
                                              data.to_user.height,
                                            )
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div class="col-lg-6">
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Education</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.education_courses
                                          ? data.to_user.education_courses
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Occupation</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.occupation_details
                                          ? data.to_user.occupation_details
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Ann. Inc. (Lakh)</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.annual_income ||
                                        data.to_user.annual_income == 0
                                          ? data.to_user.annual_income
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Working city</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.working_place_taluka
                                          ? data.to_user.working_place_taluka
                                              .name
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>

                                <!-- <div class="row">
                                  <div class="col-6">
                                    <label for="">Gan</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.gan
                                          ? data.to_user.gan.name
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div> -->
                              </div>
                              <div class="col-md-6 text-center mt-3">
                                <p>
                                  Received on
                                  {{
                                    data.created_at
                                      ? $helperService.getFormatedDate(
                                          data.created_at,
                                        )
                                      : "-"
                                  }}
                                </p>
                              </div>
                              <div class="col-md-6 text-center mt-3">
                                <p>
                                  Accepted on
                                  {{
                                    data.updated_at
                                      ? $helperService.getFormatedDate(
                                          data.updated_at,
                                        )
                                      : "-"
                                  }}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-2 col-md-4 ps-md-0">
                            <!-- <a
                              v-on:click="
                                showRemmaingtactModel(data.from_user_id)
                              "
                              class="btn btn-outline-brand-1 mb-3 w-100 px-2"
                            >
                              <i
                                class="fa fa-eye font-20 me-2"
                                aria-hidden="true"
                              ></i>
                              View Contact</a
                            > -->
                            <button
                              v-if="!data.hasViewContact"
                              v-on:click="
                                showRemmaingtactModel(data.from_user_id)
                              "
                              class="btn btn-outline-brand-1 mt-2 mb-3 w-100">
                              <i
                                class="fa fa-eye font-20 me-2"
                                aria-hidden="true"></i>
                              View Contact
                            </button>
                            <button
                              v-if="data.hasViewContact"
                              v-on:click="
                                showRemmaingtactModel(data.from_user_id)
                              "
                              class="btn btn-brand-1 mt-2 mb-3 w-100">
                              <i
                                class="fa fa-eye font-20 me-2"
                                aria-hidden="true"></i>
                              View Contact
                            </button>
                            <button
                              v-on:click="downloadProfile(data.from_user_id)"
                              class="btn btn-brand-1 w-100 mb-3">
                              <i
                                class="fa fa-download font-20 me-2"
                                aria-hidden="true"></i>
                              Download Profile
                            </button>
                          </div>
                        </div>
                        <div class="col-12 text-center mb-3">
                          <!-- <button type="button" class="btn btn-outline-brand-1">
                            <i class="fa fa-phone" aria-hidden="true"></i>
                            
                          </button> -->
                          <p class="font-medium pink-clr">
                            <i class="fa fa-phone" aria-hidden="true"></i>
                            Contact Them Earliest
                          </p>
                        </div>
                      </div>
                      <ErrorComponent
                        @retry="getRecievedIntrest(0, 'ACCEPTED')"
                        ref="errorComponent"
                        v-if="currentTab == 'ACCEPTED'" />
                      <div
                        class="row mx-0 mb-4"
                        v-if="currentTab == 'ACCEPTED'">
                        <div
                          class="col-lg-12 mt-5 text-right"
                          style="text-align-last: end">
                          <div class="page-bottom-pagination text-right">
                            <Pagination
                              @page-change="pageChange"
                              @items-per-page-change="itemsPerPageChange"
                              ref="listPagination" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Rejected Interest  -->
                    <div
                      v-if="currentTab == 'REJECTED'"
                      class="tab-pane fade"
                      id="tab_3_3"
                      :class="currentTab == 'REJECTED' ? 'show active' : ''">
                      <div
                        class="border-top pt-4"
                        v-for="(data, index) in Users"
                        :key="index">
                        <div class="row">
                          <div class="col-lg-3 col-md-4 mb-4 position-relative">
                            <div
                              :id="'ProfileSlider3_' + index"
                              class="carousel slide profile-sider"
                              data-bs-ride="carousel"
                              data-bs-interval="false">
                              <div
                                class="carousel-inner rounded-l cursor-pointer"
                                v-if="
                                  data.to_user.user_images.length > 0 ||
                                  data.to_user.user_images != null
                                ">
                                <div
                                  class="carousel-item"
                                  v-for="(data1, index1) in data.to_user
                                    .user_images"
                                  :key="index1"
                                  :class="index1 == 0 ? 'active' : ' '">
                                  <img
                                    :src="
                                      data1.image
                                        ? data1.image
                                        : 'img/profile-holder.png'
                                    "
                                    class="photos"
                                    alt="..." />
                                </div>
                              </div>
                              <div
                                class="carousel-inner rounded-l new cursor-pointer"
                                v-if="
                                  data.to_user.user_images.length == 0 ||
                                  data.to_user.user_images == null
                                ">
                                <div class="carousel-item active">
                                  <img
                                    src="img/profile-holder.png"
                                    class="photos"
                                    alt="..." />
                                </div>
                              </div>
                              <div v-show="data.to_user.user_images.length">
                                <button
                                  class="carousel-control-prev"
                                  type="button"
                                  :data-bs-target="'#ProfileSlider3_' + index"
                                  data-bs-slide="prev">
                                  <span
                                    class="carousel-control-prev-icon"
                                    aria-hidden="true"></span>
                                  <span class="visually-hidden">Previous</span>
                                </button>
                              </div>
                              <div v-show="data.to_user.user_images.length">
                                <button
                                  class="carousel-control-next"
                                  type="button"
                                  :data-bs-target="'#ProfileSlider3_' + index"
                                  data-bs-slide="next">
                                  <span
                                    class="carousel-control-next-icon"
                                    aria-hidden="true"></span>
                                  <span class="visually-hidden">Next</span>
                                </button>
                              </div>
                            </div>
                            <div
                              class="text-center my-3 carousel-counter"
                              id="slide-counter">
                              <div class="num text-white"></div>
                            </div>
                          </div>
                          <div class="col-lg-7 col-md-8 cursor-pointer">
                            <div class="row">
                              <div
                                class="col-lg-6"
                                v-on:click="
                                  $router.push(
                                    '/activity-profile-view/' +
                                      data.to_user.uuid +
                                      '/REJECTED/' +
                                      data.uuid,
                                  )
                                ">
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Registration No.</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user &&
                                        data.to_user.registration_no
                                          ? data.to_user.registration_no
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Surname</label>
                                  </div>
                                  <div
                                    class="col-6"
                                    style="word-break: break-all !important">
                                    <p class="font-medium pink-clr">
                                      <!-- {{
                                        data.to_user.first_name
                                          ? data.to_user.first_name
                                          : ""
                                      }}
                                      {{
                                        data.to_user.middle_name
                                          ? data.to_user.middle_name
                                          : ""
                                      }} -->
                                      {{
                                        data.to_user.last_name
                                          ? data.to_user.last_name
                                          : ""
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <!-- <div
                                  class="row"
                                  v-if="
                                    mydetail.is_membership_subscribed == 'N'
                                  ">
                                  <div class="col-6">
                                    <label for="">Surname</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium pink-clr">
                                      {{
                                        data.to_user.last_name
                                          ? data.to_user.last_name
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div> -->
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Date of Birth</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.dob
                                          ? $helperService.getFormatedDate(
                                              data.to_user.dob,
                                            )
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Height</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.height
                                          ? $helperService.getHeight(
                                              data.to_user.height,
                                            )
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Education</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.education_courses
                                          ? data.to_user.education_courses
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="col-lg-6"
                                v-on:click="
                                  $router.push(
                                    '/activity-profile-view/' +
                                      data.to_user.uuid +
                                      '/REJECTED/' +
                                      data.uuid,
                                  )
                                ">
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Occupation</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.occupation_details
                                          ? data.to_user.occupation_details
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Annual Income (Lakh)</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.annual_income ||
                                        data.to_user.annual_income == 0
                                          ? data.to_user.annual_income
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Working city</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.working_place_taluka
                                          ? data.to_user.working_place_taluka
                                              .name
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-6">
                                    <label for="">Native Place</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.native_place_district
                                          ? data.to_user.native_place_district
                                              .name
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <!-- <div class="row">
                                  <div class="col-6">
                                    <label for="">Gan</label>
                                  </div>
                                  <div class="col-6">
                                    <p class="font-medium">
                                      {{
                                        data.to_user.gan
                                          ? data.to_user.gan.name
                                          : "-"
                                      }}
                                    </p>
                                  </div>
                                </div> -->
                              </div>
                              <div class="col-md-6 text-center mt-3">
                                <p>
                                  Sent on
                                  {{
                                    data.created_at
                                      ? $helperService.getFormatedDate(
                                          data.created_at,
                                        )
                                      : "-"
                                  }}
                                </p>
                              </div>
                              <div class="col-md-6 text-center mt-3">
                                <p>
                                  Rejected on
                                  {{
                                    data.created_at
                                      ? $helperService.getFormatedDate(
                                          data.created_at,
                                        )
                                      : "-"
                                  }}
                                </p>
                              </div>
                              <div
                                class="col-md-6 text-center"
                                v-if="mydetail.is_membership_subscribed == 'Y'">
                                <button
                                  type="button"
                                  class="btn btn-outline-brand-1"
                                  v-on:click="accept(data, index)">
                                  <i class="fa fa-check" aria-hidden="true"></i
                                  >Accept Again
                                </button>
                              </div>
                              <div
                                class="col-md-6 text-center"
                                v-if="data.message">
                                <button
                                  type="button"
                                  v-on:click="showViewRejectpopup(data)"
                                  class="btn btn-outline-brand-1"
                                  data-bs-toggle="modal"
                                  data-bs-target="#ViewReason">
                                  <i
                                    class="fa fa-question-circle"
                                    aria-hidden="true"></i>
                                  View Reason
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <ErrorComponent
                        @retry="getRecievedIntrest(0, 'REJECTED')"
                        ref="errorComponent"
                        v-if="currentTab == 'REJECTED'" />
                      <div
                        class="row mx-0 mb-4"
                        v-if="currentTab == 'REJECTED'">
                        <div
                          class="col-lg-12 mt-5 text-right"
                          style="text-align-last: end">
                          <div class="page-bottom-pagination text-right">
                            <Pagination
                              @page-change="pageChange"
                              @items-per-page-change="itemsPerPageChange"
                              ref="listPagination" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <!-- View Contact  -->

    <TextModal ref="viewMembershipPlan">
      <div>
        <div class="row col-12 px-md-5 border-0 p-4 text-align-last-center">
          <div class="col-1" style="text-align-last: end"></div>
        </div>
        <div class="modal-body pt-0 form-style">
          <div class="row">
            <button
              type="button"
              class="btn-close"
              style="margin-left: auto; margin-top: -58px; margin-right: -10px"
              v-on:click="$refs.viewMembershipPlan.closeModal()"></button>
          </div>
          <div class="form-group">
            <h4 class="text-center">You are a free member</h4>
            <p>
              Buy a paid membership to see contact no. & some hidden information
            </p>
          </div>
          <div class="text-center">
            <router-link
              to="/membership-plans"
              class="btn btn-brand-1 btn-block">
              View membership plan
            </router-link>
          </div>
        </div>
      </div>
    </TextModal>
    <TextModal ref="remainingContacts">
      <div>
        <div class="row border-0 text-align-last-center">
          <div class="col-1" style="text-align-last: end"></div>
        </div>
        <div class="modal-body pt-0 form-style">
          <div class="row">
            <button
              type="button"
              class="btn-close"
              style="margin-left: auto"
              v-on:click="$refs.remainingContacts.closeModal()"></button>
          </div>
          <div class="form-group">
            <h4 class="text-center">View Contact</h4>
            <p>
              Your Total Remaining Contact View is -
              {{ remaining_contact_view_count }}
            </p>
          </div>
          <div class="text-center">
            <button
              type="button"
              class="btn btn-brand-1 w-100 mb-3"
              v-on:click="showContactModel()">
              View Contact
            </button>
          </div>
        </div>
      </div>
    </TextModal>
    <TextModal ref="rejectIntrestModal">
      <div class="modal-content">
        <div class="modal-header px-md-5 border-0">
          <div class="row">
            <!-- <h5 class="modal-title" id="loginModalLabel">Report</h5> -->
            <button
              type="button"
              class="btn-close"
              v-on:click="$refs.rejectIntrestModal.closeModal()"></button>
          </div>
        </div>
        <div class="modal-body px-4">
          <h5 class="modal-title font-22 mb-0 text-center mb-3">
            Rejection Reason
          </h5>
          <Form ref="rejectIntrestForm" @submit="reject()">
            <div class="floating-form mb-4">
              <div class="floating-form-group mt-4 mb-2" style="height: 130px">
                <Field
                  as="textarea"
                  type="text"
                  rows="4"
                  style="width: 100%"
                  name="message"
                  rules="required:message"
                  :validateOnInput="true"
                  v-model="rejectObj.message" />

                <!-- <label for="message"
                  >Please write your problem/suggestion</label
                > -->
                <!-- <span class="text-danger">*</span> -->
              </div>
              <ErrorMessage name="message" class="text-danger" />
            </div>
            <div class="text-center">
              <button class="btn btn-brand-1" id="submit-button">Submit</button>
            </div>
          </Form>
        </div>
      </div>
    </TextModal>
    <TextModal ref="ViewrejectMessageModal">
      <div class="modal-content">
        <div class="modal-header px-md-5 border-0">
          <div class="row">
            <!-- <h5 class="modal-title" id="loginModalLabel">Report</h5> -->
            <button
              type="button"
              class="btn-close"
              v-on:click="$refs.ViewrejectMessageModal.closeModal()"></button>
          </div>
        </div>
        <div class="modal-body px-4">
          <h5 class="modal-title font-22 mb-0 text-center mb-3">
            Rejection Reason
          </h5>
          <Form ref="rejectIntrestForm">
            <div class="floating-form mb-4">
              <div class="floating-form-group mt-4 mb-2" style="height: 130px">
                <Field
                  as="textarea"
                  type="text"
                  rows="4"
                  disabled
                  style="width: 100%"
                  name="message1"
                  rules="required:message"
                  :validateOnInput="true"
                  v-model="message" />

                <!-- <label for="message"
                  >Please write your problem/suggestion</label
                >
                <span class="text-danger">*</span> -->
              </div>
              <!-- <ErrorMessage name="message" class="text-danger" /> -->
            </div>
            <!-- <div class="text-center">
              <button class="btn btn-brand-1" id="submit-button">Submit</button>
            </div> -->
          </Form>
        </div>
      </div>
    </TextModal>
    <ConteactViewModel ref="ConteactViewModel" />
  </div>
</template>
<script>
import $ from "jquery";
import ErrorComponent from "@/components/ErrorComponent";
import ConteactViewModel from "@/components/ConteactViewModel";
import Pagination from "@/components/Pagination.vue";
import TextModal from "@/components/TextModal.vue";
import { Form, Field, ErrorMessage } from "vee-validate";
// import moment from "moment";
//import router from "../../router";
export default {
  name: "MyActivity",
  components: {
    ErrorComponent,
    ConteactViewModel,
    Pagination,
    TextModal,
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    return {
      loader: false,
      uuid: "",
      message: "",
      remaining_contact_view_count: 0,
      offset: 0,
      count: {},
      currentTab: this.$route.query.tab || "PENDING",
      mydetail: {},
      contentDetail: {},
      Users: [],
      Users1: {},
      rejectObj: {
        uuid: "",
        index: "",
        message: "",
      },
    };
  },

  mounted() {
    var totalItems = $(".carousel-item").length;
    var currentIndex = $(".carousel-item.active").index() + 1;
    $(".num").html("" + currentIndex + "/" + totalItems + "");

    $("#ProfileSlider").bind("slid", function () {
      currentIndex = $(".carousel-item.active").index() + 1;
      $(".num").html("" + currentIndex + "/" + totalItems + "");
    });
    this.getActivityCount();
    const tab = this.$route.query.tab || "PENDING";
    this.changeTab(tab);
    this.getMeCall();
  },
  methods: {
    showViewRejectpopup(data) {
      if (data.message) {
        this.message = data.message;

        this.$refs.ViewrejectMessageModal.showModal();
      }
    },
    showRejectpopup(data, index) {
      if (this.mydetail.is_membership_subscribed != "Y") {
        this.$notify({
          type: "error",
          text: "To Accept or Reject interest, you have to purchase subscription plan",
        });
        return;
      }
      this.$refs.rejectIntrestForm.resetForm();
      if (data) {
        this.rejectObj.uuid = data.uuid;
      }
      if (index) {
        this.rejectObj.index = index;
      }

      this.$refs.rejectIntrestModal.showModal();
    },
    reject() {
      if (this.rejectObj.uuid) {
        this.$api
          .putAPI({
            _action: "/intrest-reject",
            _body: this.rejectObj,
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            this.getActivityCount();
            this.Users.splice(this.rejectObj.index, 1);
            this.$refs.rejectIntrestModal.closeModal();
          })
          .catch(() => {});
      } else {
        return;
      }
    },
    sendIntrest(data) {
      var obj = {};
      obj.to_user_id = data.from_user_id ? data.from_user_id : "";
      this.$api
        .postAPI({
          _action: "/send-intrest",
          _body: obj,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.getActivityCount();
          return (data.hasSentIntrest = 1);
        })
        .catch(() => {});
    },
    notIntrested(data) {
      var obj = {};
      obj.to_user_id = data.from_user_id ? data.from_user_id : "";
      this.$api
        .putAPI({
          _action: "/cancel-request/" + obj.to_user_id,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          return (data.hasSentIntrest = 0);
        })
        .catch(() => {});
    },
    pageChange(offset) {
      this.getRecievedIntrest(offset - 1, this.currentTab);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getRecievedIntrest(0, this.currentTab);
    },
    getActivityCount() {
      this.$api
        .getAPI({
          _action: "/get-activity-count",
        })
        .then((res) => {
          this.count = res;
        })
        .catch(() => {});
    },

    smsEmailUserDetails(uuid) {
      this.$api
        .getAPI({
          _action: "/email-detail/" + uuid,
        })
        .then(() => {
          this.$notify({
            type: "success",
            text: "User details are successfully sent to your registered email and mobile number",
          });
          this.$refs.viewContactmodel.closeModal();
        })
        .catch(() => {});
    },
    showRemmaingtactModel(uuid) {
      this.$refs.errorComponent.updateFormLoader(true);
      if (uuid) {
        this.uuid = uuid;
      }
      this.$api
        .getAPI({
          _action: "/remmaing-contact-detail/" + this.uuid,
        })
        .then((res) => {
          this.$refs.errorComponent.updateFormLoader(false);
          if (res.contact_view && res.contact_view > 0) {
            this.remaining_contact_view_count = res.contact_view;
            this.$refs.remainingContacts.showModal();
          } else if (res.already_viewed && res.already_viewed == 1) {
            this.contentDetail = res;
            this.$refs.ConteactViewModel.showModal(this.contentDetail);
          } else {
            this.$refs.viewMembershipPlan.showModal();
          }
        })
        .catch(() => {
          this.$refs.errorComponent.updateFormLoader(false);
        });
    },
    showContactModel() {
      this.$refs.remainingContacts.closeModal();
      this.$api
        .getAPI({
          _action: "/contact-detail/" + this.uuid,
        })
        .then((res) => {
          if (res) {
            this.contentDetail = res;
            this.$refs.remainingContacts.closeModal();
            this.getRecievedIntrest(this.offset);
            this.$refs.ConteactViewModel.showModal(this.contentDetail);
          }
        })
        .catch(() => {});
    },
    changeTab(tab) {
      this.currentTab = tab;
      this.$router.replace({
        query: {
          ...this.$route.query,
          tab: tab,
        },
      });
      if (tab == "PENDING") {
        this.getRecievedIntrest(0, "PENDING");
      }
      if (tab == "ACCEPTED") {
        this.getRecievedIntrest(0, "ACCEPTED");
      }
      if (tab == "REJECTED") {
        this.getRecievedIntrest(0, "REJECTED");
      }
    },
    downloadProfile(uuid) {
      var url =
        this.$api.getBaseUrl() +
        "get/biodata?uuid=" +
        uuid +
        "&from_uuid=" +
        this.mydetail.uuid;
      window.open(url);
    },
    getMeCall() {
      this.$api
        .getAPI({
          _action: "/user/me",
        })
        .then((res) => {
          this.mydetail = res;
          this.$store.commit("setUser", res);
        })
        .catch(() => {});
    },
    getRecievedIntrest(offset, type) {
      this.loader = true;
      if (this.$refs.errorComponent) {
        this.$refs.errorComponent.updateListLoader(true);
      }

      var obj = {};
      if (offset == 0) {
        this.Users = [];
      }
      obj.offset = offset;
      obj.status = type;
      this.$api
        .getAPI({
          _action: "/intrest-recieved/list",
          _body: obj,
        })
        .then((res) => {
          this.loader = false;
          this.Users = res.list;
          this.offset = res.next_offset;
          if (offset == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "Profile Not Available");
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          this.$refs.errorComponent.updateListLoader(false);
        });
    },
    accept(data, index) {
      this.loader = true;
      this.$refs.errorComponent.updateFormLoader(true);
      if (this.mydetail.is_membership_subscribed != "Y") {
        this.$notify({
          type: "error",
          text: "To Accept or Reject interest, you have to purchase subscription plan",
        });
        return;
      }
      var obj = {};
      obj.uuid = data.uuid ? data.uuid : "";
      if (obj.uuid) {
        this.$api
          .putAPI({
            _action: "/intrest-accept",
            _body: obj,
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            this.getActivityCount();
            this.Users.splice(index, 1);
            if (this.$refs.errorComponent) {
              this.loader = false;
              this.$refs.errorComponent.updateFormLoader(false);
            }
          })
          .catch(() => {});
      } else {
        return;
      }
    },
  },
};
</script>
